import React, { useCallback, useState } from 'react'
import { Form } from 'react-bootstrap'

interface INumberInput {
  defaultValue?: number
  placeholder?: string
  onChange: (value: number | '') => void
  onEntered?: (value: number | '') => void
  style?: React.CSSProperties
}

const NumberInput: React.FC<INumberInput> = ({
  defaultValue,
  placeholder,
  onChange,
  onEntered,
  style,
}) => {
  const [value, setValue] = useState<number | ''>(defaultValue || '')

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      let value_ = event.target.value
      if (value_ === '') {
        setValue('')
        onChange('')
      } else {
        let value_int = parseInt(value_)
        if (!value_int) {
          value_int = 0
        }
        onChange(value_int)
        setValue(value_int)
      }
    },
    [onChange]
  )

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (onEntered && event.key === 'Enter') onEntered(value)
    },
    [onEntered, value]
  )

  const handleBlur = useCallback(() => {
    if (onEntered) onEntered(value)
  }, [onEntered, value])

  return (
    <Form.Control
      value={value}
      type='number'
      placeholder={placeholder}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      style={style}
    />
  )
}
export default NumberInput
